import { render, staticRenderFns } from "./BadgeRenderer.vue?vue&type=template&id=31d96642&"
import script from "./BadgeRenderer.vue?vue&type=script&lang=js&"
export * from "./BadgeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports